import script from "./consultList.vue?vue&type=script&setup=true&lang=js"
export * from "./consultList.vue?vue&type=script&setup=true&lang=js"

import "./consultList.vue?vue&type=style&index=0&id=44ee0fee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ee0fee"]])

export default __exports__